import { Component, OnInit, ElementRef, ViewChild, ViewEncapsulation, Optional, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ApiService } from 'src/app/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-update-group',
  templateUrl: './create-update-group.component.html',
  styleUrls: ['./create-update-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateUpdateGroupComponent implements OnInit {
  showSpinner = false;
  groupList= [];
  type;
  groupData;
  allGroups = [];
  rowList = ['vsagh','hsdgh','hdfshb'];
  searchText;
  groupId;
  groupspecificList = [];
  groupInfo = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl('')
  });
  boardMemberList = [];
  selectedBM = [];
  suggestBM = [];
  filterUserWithoutSelected = [];
  filtered_selectedBM = [];
  filtered_suggestBM = [];


  displayedColumns = ['boardmember_name','division', 'id'];
  // dataSource = ELEMENT_DATA;
  start: number = 0;
  limit: number = 5;
  end: number = this.limit + this.start;
  selectedRowIndex: number = null;
  tabledataSelected;

  displayedColumnsSuggested = ['name','division', 'id'];
  startSuggested: number = 0;
  limitSuggested: number = 5;
  endSuggested: number = this.limitSuggested + this.startSuggested;
  selectedRowIndexSuggested: number = null;
  tabledataSuggested;
  
  constructor(
    public dialogRef: MatDialogRef<CreateUpdateGroupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    this.groupList = data.groupList;
    this.type = data.type;
    this.groupData = data.groupInfo;
    this.groupId = data.groupInfo.id;
    
    // this.groupInfo = new FormGroup({
    //   name: new FormControl(data.groupInfo.name, [Validators.required]),
    //   description: new FormControl(data.groupInfo.description, [])
    // });
    console.log(this.groupInfo);
   }

  ngOnInit(): void {
    if(this.groupData){
      this.groupInfo.controls['name'].setValue(this.groupData.name);
      this.groupInfo.controls['description'].setValue(this.groupData.description);

    }
    
    if(this.type != 'new'){
      this.refreshGroupSpecificBMList('new');
    }

    setTimeout(() => {
      this.refreshBMList('new');
    }, 1000);

    setTimeout(() => {
      
    });
    
  }

  refreshGroupSpecificBMList(type){
    let data ={
      "group_id":this.groupId
    };
    this.showSpinner = true
    this._apiService.getGroupSpecificBMList(data).subscribe(res => {
      if (res) {
        this.tabledataSelected = [];
        this.groupspecificList = res;
        this.filtered_selectedBM = res;
        if(type == 'new'){
          this.tabledataSelected = this.getTableData(this.start, this.end);
          console.log('tabledataSelected',this.tabledataSelected)
          this.updateIndex();
        }else if(type == 'refresh'){
          this.start = 0;
          this.end = 5;
          this.tabledataSelected = this.getTableData(this.start, this.end);
          this.updateIndex();
        }
        
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }
  refreshBMList(type){
    this._apiService.getbmList().subscribe(res => {
      if (res) {
        this.showSpinner = false;
        this.tabledataSuggested = [];
        this.boardMemberList = res;
        this.filterUserWithoutSelected = []
        for(let i=0; i<this.boardMemberList.length; i++){
          if(this.groupspecificList.filter(e => e.boardmember_name === this.boardMemberList[i].name).length == 0){
            this.filterUserWithoutSelected.push(this.boardMemberList[i]);
          }
        }
        this.filtered_suggestBM = this.filterUserWithoutSelected;
        if(type == 'new'){
          this.tabledataSuggested = this.getTableDataSuggested(this.startSuggested, this.endSuggested);
          console.log(this.tabledataSuggested)
          this.updateIndexSuggested();
        }else if(type == 'refresh'){
          this.startSuggested = 0;
          this.endSuggested = 5;
          this.tabledataSuggested = this.getTableDataSuggested(this.startSuggested, this.endSuggested);
          this.updateIndexSuggested();
        }
        
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }

  save(){
    if(this.type == 'new'){
      if (this.groupList.filter(e => e.name === this.groupInfo.get('name').value).length == 0) {
        let createGroup = {
          name: this.groupInfo.get('name').value,
          description: this.groupInfo.get('description').value,
        }
        this.showSpinner = true;
        this._apiService.createGroup(createGroup).subscribe(res => {
          if (res) {
            this.showSpinner = false;
            this.dialogRef.close();
            console.log(res);
          }
        },
        (error)=>{
          this.showSpinner = false;
          this.dialogRef.close();
        });
      }else{
          this._snackBar.open('Group Already Exists with Same Name', 'OK', { duration: 3000 });
        }
    }else if(this.type == 'edit'){
      let updateGroup = {
        id: this.groupId,
        name: this.groupInfo.get('name').value,
        description: this.groupInfo.get('description').value,
      }
      this.showSpinner = true;
      this._apiService.updateGroup(updateGroup).subscribe(res => {
        if (res) {
          this.showSpinner = false;
          this.dialogRef.close();
          console.log(res);
        }
      },
      (error)=>{
        this.showSpinner = false;
        this.dialogRef.close();
      });
    }
  }

  close(){
    this.dialogRef.close();
  }

  mychange(e){
    let filtered_selectedBM = this.groupspecificList.filter(ele => ele.boardmember_name.toLowerCase().includes(e.toLowerCase()));
    this.filtered_selectedBM = filtered_selectedBM;
    let filtered_suggestBM = this.filterUserWithoutSelected.filter(ele => ele.name.toLowerCase().includes(e.toLowerCase()));
    this.filtered_suggestBM = filtered_suggestBM;
    this.startSuggested = 0;
    this.endSuggested = 5;
    this.tabledataSuggested = this.getTableDataSuggested(this.startSuggested, this.endSuggested);
    this.updateIndexSuggested();
    this.start = 0;
    this.end = 5;
    this.tabledataSelected = this.getTableData(this.start, this.end);
    this.updateIndex();
  }

  addToTheGroup(bmInfo){
    console.log(bmInfo)
    let bmInfoToAdd = {
      "group_name":this.groupData.name,
      "group_id":this.groupId,
      "boardmember_id":bmInfo.id,
      "boardmember_name":bmInfo.name,
      "phone_number":bmInfo.phone,
      "division":bmInfo.division
    }
    this.showSpinner = true;
    this._apiService.addBoardMemberToGroup(bmInfoToAdd).subscribe(res => {
      if (res) {
        console.log(res);
        setTimeout(() => {
          console.log('GSBM')
          this.refreshGroupSpecificBMList('refresh');
          setTimeout(() => {
            console.log('BM')
            this.refreshBMList('refresh');
          }, 500);
        }, 500);
        
      }
    },
    (error)=>{
       this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
    });
  }

  removebmFromGroup(id){
    this.showSpinner = true;
    this._apiService.removeBoardMemberFromGroup(id).subscribe(res => {
      if (res) {
        console.log(res);
        setTimeout(() => {
          console.log('GSBM')
          this.refreshGroupSpecificBMList('refresh');
          setTimeout(() => {
            console.log('BM')
            this.refreshBMList('refresh');
          }, 500);
        }, 500);
        
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }

  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight 
    const tableScrollHeight = e.target.scrollHeight 
    const scrollLocation = e.target.scrollTop; 
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;  
    if (scrollLocation > limit) {
      let data = this.getTableData(this.start, this.end);;
      this.tabledataSelected = this.tabledataSelected.concat(data);
      this.updateIndex();
    }
  }

  getTableData(start, end) {
    return this.filtered_selectedBM.filter((value, index) => index >= start && index < end)
  }

  updateIndex() {
    this.start = this.end;
    this.end = this.limit + this.start;
  }

  selectedRow(row) {
    console.log('selectedRow', row)
  }

  onTableScrollSuggested(e) {
    const tableViewHeight = e.target.offsetHeight // viewport
    const tableScrollHeight = e.target.scrollHeight // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    
    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;  
    if (scrollLocation > limit) {
      let data = this.getTableDataSuggested(this.startSuggested, this.endSuggested);
      this.tabledataSuggested = this.tabledataSuggested.concat(data);
      this.updateIndexSuggested();
    }
  }

  getTableDataSuggested(start, end) {
    return this.filtered_suggestBM.filter((value, index) => index >= start && index < end)
  }

  updateIndexSuggested() {
    this.startSuggested = this.endSuggested;
    this.endSuggested = this.limitSuggested + this.startSuggested;
  }


}

